<script>
    // CommitChart.js
    import {Line} from 'vue-chartjs'

    export default {
        extends: Line,
        data() {
            return {
                lastData: this.data
            }
        },
        props: {
            labels: {
                required: true,
                type: Array
            },
            data: {
                required: true,
                type: Array
            },
            width: {
                default: 700,
                type: Number
            },
            height: {
                default: 300,
                type: Number
            },
            title: {
                type: String,
                default: ''
            }
        },
        mounted() {
            this.renderLineChart(false);
            window.addEventListener('resize',function (){
                this.reRender(false)
            }.bind(this));
        },
        computed: {
            chartData: function () {
                return this.data;
            }
        },
        methods: {
            renderLineChart: function (animated = false) {
              //  this.$refs.canvas.style['max-width'] = this.width + 'px';
               // this.$refs.canvas.style['max-height'] = this.height + 'px';
                const options = {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: {
                        duration: animated ? 1000 : 0
                    },
                    legend: {
                        display: false,
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontStyle: 'bold'
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                fontStyle: 'bold'
                            }
                        }]
                    },
                    title: {
                        display: this.title !== '',
                        text: this.title,
                        fontSize: 12
                    }
                };
                // Overwriting base render method with actual data.
                this.renderChart({
                    labels: this.labels,
                    datasets: [
                        {
                            lineTension: 0,
                            borderColor: '#da2567',
                            pointBackgroundColor: '#da2567',
                            backgroundColor: 'rgba(0,0,0,0)',
                            pointBorderWidth: 5,
                            borderWidth: 2,
                            data: this.data
                        }
                    ]
                }, options)
            },
            arrayDiff(a, b) {
                return [...b.reduce( (acc, v) => acc.set(v, (acc.get(v) || 0) - 1),
                    a.reduce( (acc, v) => acc.set(v, (acc.get(v) || 0) + 1), new Map() )
                )].reduce( (acc, [v, count]) => acc.concat(Array(Math.abs(count)).fill(v)), [] );
            },
            reRender(animated){
                this._data._chart.destroy();
                this.renderLineChart(animated);
            }
        },
        watch: {
            data: function () {
                if (this.arrayDiff(this.data, this.lastData).length > 0) {
                    this.lastData = this.data;
                    this.reRender(true);
                }
            }
        }

    }
</script>

<style scoped>

    canvas {
        background-color: white;
        padding: 12px;
        margin: auto;
    }


</style>